export const HIDE_LOADER_GALLERY = 'HIDE_LOADER_GALLERY';
export const SHOW_LOADER_GALLERY = 'SHOW_LOADER_GALLERY';
